<template>
  <div>
    <el-form :inline="true" ref="searchForm" :model="searchForm" class="forTbFilter" @submit.native.prevent>
      <el-form-item label="商户号：">
        <el-input v-model.trim="searchForm.mchId" placeholder="支持模糊搜索" clearable></el-input>
      </el-form-item>

      <el-form-item label="支付类型：">
        <el-select v-model="searchForm.subType" clearable>
          <el-option label="微信支付" value="20"></el-option>
          <el-option label="乐刷支付" value="50"></el-option>
          <el-option label="易支付" value="62"></el-option>
          <el-option label="支付宝" value="61"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="btnArea">
        <el-button type="primary" plain icon="el-icon-search" @click="getPkgGroupListPageHandle">搜索</el-button>
        <el-button type="primary" @click="showAddPkgGroup">新建商户</el-button>
        <el-button type="success" icon="el-icon-s-ticket" @click="autoPayState">自动切换商户</el-button>
        <el-button type="primary" @click="updateCollectionConfig()" plain icon="el-icon-edit">上传P12证书</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="tbpg.tableData" border highlight-current-row style="width: 100%;"
      :header-cell-style="{ background: '#f5f5f5' }">
      <el-table-column type="index" label="序号" width="50"></el-table-column>
      <el-table-column prop="remark" label="商户备注" align="center" show-overflow-tooltip></el-table-column>
      <el-table-column prop="payName" label="商户类型" align="center" show-overflow-tooltip></el-table-column>  
      <el-table-column prop="mchId" label="商户号" align="center" show-overflow-tooltip></el-table-column>
      <el-table-column prop="mchPwd" label="商户密钥" align="center" show-overflow-tooltip></el-table-column>

      <el-table-column align="center" label="商户状态">
        <template v-slot="scope">
          <el-tooltip v-if="scope.row.stateName == '在用'" content="默认支付商户号">
            <p style="color:green"> {{ scope.row.stateName }}</p>
          </el-tooltip>
          <el-tooltip v-else-if="scope.row.stateName == '待用'" content="待用商户号">
            <p style="color:blue"> {{ scope.row.stateName }}</p>
          </el-tooltip>
          <el-tooltip v-else content="禁用支付商户号">
            <p style="color:crimson"> {{ scope.row.stateName }}</p>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column prop="sumPrice" label="已收款金额" align="center" show-overflow-tooltip></el-table-column>
      <el-table-column prop="countNum" label="已收款笔数" align="center" show-overflow-tooltip></el-table-column>
      <el-table-column prop="maxPrice" label="限制交易金额" align="center" show-overflow-tooltip></el-table-column>
      <el-table-column align="center" label="系统备注">
        <template v-slot="scope">
          <el-tooltip :content="scope.row.sysRemark">
            <p style="color:crimson"> {{ scope.row.sysRemark }}</p>
          </el-tooltip>
        </template>
      </el-table-column>

      <el-table-column label="操作" align="center" width="250">
        <template slot-scope="scope">
          <el-button type="text" size="small" v-if="scope.row.subState == 0" style="color: green"
            @click="updateSimState(scope.row.id, scope.row.subState, scope.row.subType)">
            {{ showbtnText(scope.row.subState) }}
          </el-button>
          <el-button type="text" size="small" @click="showEditPkgGroup(scope.row)">编辑</el-button>
          <el-button type="text" size="small" style="color: red" @click="changeStateHandle(scope.row.id)">删除配置</el-button>
        </template>

      </el-table-column>
    </el-table>
    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="tbpg.currentPage"
      :page-sizes="[15, 50, 100, 500]" :page-size="tbpg.pageSize" background
      layout="total, sizes, prev, pager, next, jumper" :total="tbpg.total">
    </el-pagination>
    <el-dialog :append-to-body="true" :title="title" :visible.sync="addGroupVisibale" width="600px" @close="cancel"
      :close-on-click-modal="false">
      <el-form ref="addOrEditGroupForm" :model="addOrEditGroupForm" :rules="addOrEditGroupRules" label-width="120px">

        <el-form-item label="商户类型：" prop="">
          <el-radio-group v-model="addOrEditGroupForm.subType" @change="updateNote()">
            <el-radio :label="20">微信商户</el-radio>
            <el-radio :label="50">乐刷商户</el-radio>
            <el-radio :label="62">易支付</el-radio>
            <el-radio :label="61">支付宝</el-radio>
            <!-- <el-radio :label="68">支付宝</el-radio> -->
            <!-- <el-radio :label="60">汇付商户</el-radio>
            <el-radio :label="62">云支付</el-radio> -->
          </el-radio-group>
        </el-form-item>
        
        <el-form-item label="商户备注：" prop="remark">
          <el-input v-model.trim="addOrEditGroupForm.remark" placeholder="" clearable></el-input>
        </el-form-item>
        
        <el-form-item label="商户号：" prop="mchId">
          <el-input v-model.trim="addOrEditGroupForm.mchId" :placeholder="subIdNote" clearable></el-input>
        </el-form-item>
        <el-form-item label="商户密钥：" prop="mchPwd">
          <el-input v-model.trim="addOrEditGroupForm.mchPwd" :placeholder="subKeyNote" clearable></el-input>
        </el-form-item>
        <el-form-item label="回调密钥：" prop="mchPwdKey">
          <el-input v-model.trim="addOrEditGroupForm.mchPwdKey" :placeholder="subPwdKeyNote" clearable></el-input>
        </el-form-item>

        <el-form-item label="商户状态：" prop="">
          <el-radio-group v-model="addOrEditGroupForm.subState">
            <el-radio :label="0">待用</el-radio>
            <el-radio :label="1">在用</el-radio>
            <el-radio :label="2">禁用</el-radio>
          </el-radio-group>
        </el-form-item>


        <el-form-item label="已收款金额：" prop="sumPrice" v-if="!addFlag">
          <el-input v-model.trim="addOrEditGroupForm.sumPrice" placeholder="" clearable></el-input>
        </el-form-item>

        <el-form-item label="已收款笔数：" prop="countNum" v-if="!addFlag">
          <el-input v-model.trim="addOrEditGroupForm.countNum" placeholder="" clearable></el-input>
        </el-form-item>

        <el-form-item label="限制交易金额：" prop="maxPrice">
          <el-input v-model.trim="addOrEditGroupForm.maxPrice" placeholder="达到交易金额后，则不再收款。（/元）" clearable></el-input>
        </el-form-item>

        <el-form-item label="系统备注：" prop="sysRemark" v-if="!addFlag">
          <el-input v-model.trim="addOrEditGroupForm.sysRemark" placeholder="" clearable></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="success" plain icon="el-icon-plus" @click="addOrEidtGroupHandle">确 定</el-button>
      </div>
    </el-dialog>


    <el-dialog :append-to-body="true" class="formDialog" title="自动切换商户号" :visible.sync="payAutoFlg" width="600px"
      @close="autoCancel" :close-on-click-modal="false">
      <el-form ref="autoInfo" :model="autoInfo" label-width="120px">
        <el-form-item label="切换状态：" prop="">
          <el-radio-group v-model="autoInfo.payAutoState">
            <el-radio :label="0">关闭切换</el-radio>
            <el-radio :label="1">每次收款随机切换</el-radio>
            <el-radio :label="3">支付一笔换个商户</el-radio>
          </el-radio-group>
        </el-form-item>

      </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="autoCancel">取 消</el-button>
            <el-button type="primary" @click="sureAutoState()">确 定</el-button>
          </div>
    </el-dialog>



    <el-dialog :append-to-body="true" title="上传P12证书" :visible.sync="collectionConfigVisible" width="600px"
      :close-on-click-modal="false">
      <p style="color:red">如微信商户号是123456。 则上传p12证书命名为 123456.p12</p>
      <el-form :model="collectionConfigFormdata" :rules="collectionConfigRules" ref="collectionConfigForm"
        label-width="120px" class="demo-ruleForm">
        <el-form-item label="商户证书：">
          <div class="toChooseFileBtn"></div>
          <input multiple type="file" ref="file" id="secondBack-uploadFile" class="uploadFile"
            @change="chooseFile($event)">
          <p>
            <span v-show="collectPkcsFileName == ''" style="color: #F56C6C;">未选择文件</span>
            <span v-show="collectPkcsFileName != ''">已选择文件 {{ collectPkcsFileName }}</span>
          </p>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelToSetCollectionConfig()">取 消</el-button>
        <el-button type="primary" @click="collectionConfigHandle()">保 存</el-button>
      </span>
    </el-dialog>


  </div>
</template>
<script>
import { getPkgGroupListPage, addPkgGroup, updatePkgGroup, adminCollectionConfig, getPkgIsMonthOption } from '@/api/package.js'
import common from '@/utils/common.js'
import Clipboard from 'clipboard';
export default {
  data() {
    return {
      collectionConfigFormdata: {
        wxAppId: null,
        wxMchId: null,
        wxKeySign: null,
        wxAppSecret: null,
        p12: null,
        collectPkcsUrl: null,
      },
      collectPkcsFileName: '',


      subIdNote: '商户号',
      subKeyNote: '商户密钥',
      subPwdKeyNote: '选填',

      autoFlg: false,
      updateAuto: {
        id: '',
        autoState: '',
        autoPkgId: ''
      },
      existBackImg: false,
      shareGroup: false,
      existBackImg1: false,
      shareGroup1: false,
      shareGroup11: false,
      shareForm: {
        id: "",
        name: "",
        subId: "",
        subKey: "",
        shareName: "",
        shareImg: "",
        priceImgUrl: "",
        isShare: "",

        shareType: '',
        shareYongjing: '',
        sharePrice: '',
        shareTypeOrderBy: '',
        shareShopOrderBY: '',

      },
      isMiaoList: [

        {
          code: 0,
          description: '不秒反'
        },
        {
          code: 1,
          description: '一次性秒反'
        },
        {
          code: 2,
          description: '一次性秒反+套餐秒反'
        }
      ],
      urls: '',
      shareImgs: false,
      searchForm: {
        id: "",
        mchId: '',
        mchPwd: '',
        mchPwdKey: '',
        subType: '',
        subState: '',
        remark: ''
      },
      tbpg: {
        tableData: [],
        currentPage: 1,
        pageSize: 15,
        total: 0,
      },
      addOrEditGroupForm: {
        id: "",
        mchId: '',
        mchPwd: '',
        mchPwdKey: '',
        subType: '',
        subState: '',
        remark: '',
        countNum: '',
        sumPrice: '',
        sysRemark: '',
        maxPrice: ''
      },
      branchSupplierOption: [],
      branchSupplierOptions: [],
      isPriceOption: [
        {
          code: 0,
          description: '不限制'
        },
        {
          code: 1,
          description: '限制余额'
        },
        {
          code: 2,
          description: '限制余额并且开户预存'
        }
      ],
      isVoiceOption: [
        {
          code: 0,
          description: '流量'
        },
        {
          code: 1,
          description: '流量+语音'
        }
      ],
      currentId: '',
      addFlag: null,
      addGroupVisibale: false,
      title: '',
      pkgTypeOption: [],
      supplierOption: [],
      isMonthOption: [],
      addOrEditGroupRules: {
        name: [{ required: true, message: '请输入套餐名称', trigger: 'blur' }],
        type: [{ required: true, message: '请选择套餐名称', trigger: 'change' }],
        isNextMonth: [{ required: true, message: '请选择套餐名称', trigger: 'change' }],
        supplierType: [{ required: true, message: '请选择套餐名称', trigger: 'change' }]
      },
      autoInfo: {
        payAutoState: '',
      },
      payAutoFlg: false,
      collectionConfigVisible: false,
    }
  },
  methods: {
    cancelToSetCollectionConfig() {
      this.collectPkcsFileName = '';
      this.collectionConfigVisible = false;
    },
    updateCollectionConfig() {
      this.collectionConfigVisible = true;
    },
    chooseFile(event) {
      let files = event.target.files;
      let filename = files[0].name          //只有一个文件
      if (filename.lastIndexOf('.') <= 0) {
        return alert("Please add a valid image!")        //判断文件是否有效
      }
      let fileReader = new FileReader()                //内置方法new FileReader()   读取文件
      fileReader.readAsDataURL(files[0])
      this.collectionConfigFormdata.p12 = files[0];
      this.collectPkcsFileName = filename;
    },
    //收款配置
    collectionConfigHandle() {
      this.$refs["collectionConfigForm"].validate((valid) => {
        if (valid) {
          this.$confirm("确定要上传吗？", "提示", {
            confirmButtonText: '确定',
            cancelButtonText: '取消'
          }).then(() => {
            let formdata = new FormData();
            Object.keys(this.collectionConfigFormdata).forEach((key) => {
              formdata.append(key, this.collectionConfigFormdata[key]);
            });
            adminCollectionConfig(formdata).then(res => {
              if (res.data.code == 200) {
                this.$message.success(res.data.message)
                this.cancelToSetCollectionConfig();
              } else {
                this.$message.error(res.data.message)
              }
            })
          }).catch(() => {

          });
        }
      });

    },





    autoPayState() {
      common.sysRequest("pkg/group/select/auto/state", {}, "post").then((res) => {
        if (res.data.code == 200) {
          this.autoInfo.payAutoState = res.data.data;
          this.payAutoFlg = true;
        } else {
          this.$message.error(res.data.message);
        }
      })
        .catch((err) => console.error(err));
    },
    sureAutoState() {
      var data = {
        state: this.autoInfo.payAutoState
      }
      common.sysRequest("pkg/group/update/auto/state", data, "post").then((res) => {
        if (res.data.code == 200) {
          this.payAutoState = res.data.data;
          this.payAutoFlg = false;
          this.$message.success(res.data.message);
        } else {
          this.$message.error(res.data.message);
        }
      })
        .catch((err) => console.error(err));
    },
    autoCancel() {
      this.payAutoFlg = false;
    },

    updateNote() {
      var payType = this.addOrEditGroupForm.subType;
      if (payType == 50) {
        this.subIdNote = '乐刷商户号';
        this.subKeyNote = '乐刷支付密钥';
        this.subPwdKeyNote = '乐刷回调密钥';
      } else if (payType == 20) {
        this.subIdNote = '微信商户号';
        this.subKeyNote = '微信商户密钥';
        this.subPwdKeyNote = '选填';
      } else if (payType == 60) {
        this.subIdNote = '汇付商户号 以app_ 开头的商户信息';
        this.subKeyNote = '汇付密钥  以api_live开头密钥信息';
        this.subPwdKeyNote = '选填';
      } else if (payType == 30) {
        this.subIdNote = '商户号';
        this.subKeyNote = '支付通道ID';
        this.subPwdKeyNote = 'MD5密钥';
      } else if (payType == 80) {
        this.subIdNote = '斗洪商户号  一般以666开头的商户号';
        this.subKeyNote = '斗洪公钥';
        this.subPwdKeyNote = '公众号appid和产品编码（问上游要） 中间用-隔开';
      } else if (payType == 61) {
        this.subIdNote = '支付宝appid';
        this.subKeyNote = '应用私钥';
        this.subPwdKeyNote = '支付宝公钥';
      } else if (payType == 66) {
        this.subIdNote = '商户编号-商户标识（中间用 - 隔开）';
        this.subKeyNote = '公钥';
        this.subPwdKeyNote = '私钥';
      } else if (payType == 62) {
        this.subIdNote = '商户编号';
        this.subKeyNote = '商户密钥';
        this.subPwdKeyNote = '支付域名';
      } else if (payType == 61) {
        this.subIdNote = '商户ID';
        this.subKeyNote = '操作者账号';
        this.subPwdKeyNote = '授权码-salt 如：1423047220000003-Of9sgQCjuZ';
      }
    },
    updateSimState(id, subState, subType) {
      var data = {
        id: id,
        subState: 1,
        subType: subType
      }
      common.sysRequest("pkg/group/update/pay/state", data, "post")
        .then((res) => {
          if (res.data.code == 200) {
            this.getPkgGroupListPageHandle();
            this.autoFlg = false;
            this.$message.success(res.data.message);
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch((err) => console.error(err));

    },

    showbtnText(state) {
      return common.showTxtByState(state, { 0: "禁用", 1: "启用" });
    },
    updateAutoSure() {
      common.sysRequest("pkg/group/update/auto/pkg", this.updateAuto, "post")
        .then((res) => {
          if (res.data.code == 200) {
            this.getPkgGroupListPageHandle();
            this.autoFlg = false;
            this.$message.success(res.data.message);
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch((err) => console.error(err));
    },
    updateAutoState(row) {
      this.updateAuto.id = row.id;
      this.updateAuto.autoPkgId = row.autoPkgId;
      this.updateAuto.autoState = row.autoState;
      this.autoFlg = true;
    },
    addOrEidtPkgHandle() {
      let fd = new FormData();
      Object.keys(this.shareForm).forEach((key) => {
        fd.append(key, this.shareForm[key]);
      });
      fd.append("title", this.$refs.file1.files[0]);

      common
        .sysRequest("pkg/group/insert/share", fd, "post")
        .then((res) => {
          if (res.data.code == 200) {
            this.$refs.file1.value = "";
            this.$message.success(res.data.message);
            callback(res);
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch((err) => console.error(err));

      var _this = this;
      function callback(res) {
        if (res.data.code == 200) {
          _this.shareGroup = false;
        } else {
          _this.$message.error(res.data.message);
        }
      }
    },
    cancel12() {
      this.autoFlg = false;
      this.shareGroup = false;
      this.existBackImg1 = false;
      this.shareGroup1 = false;
      this.shareGroup11 = false;
      this.$refs.shareForm.resetFields();
    },
    sharePkgGroup(row) {

      this.shareForm.shareType = row.shareType;
      this.shareForm.sharePrice = row.sharePrice;
      this.shareForm.shareYongjing = row.shareYongjing;
      this.shareForm.shareTypeOrderBy = row.shareTypeOrderBy;
      this.shareForm.shareShopOrderBY = row.shareShopOrderBY;

      this.shareForm.id = row.id;
      this.shareForm.shareName = row.shareName;
      this.shareForm.shareImg = row.shareImg;
      this.shareForm.isShare = row.isShare;
      this.existBackImg = true;
      this.shareGroup = true;
    },
    //复制功能
    copy() {
      var clipboard = new Clipboard('.copy_url')
      clipboard.on('success', e => {
        this.$message.success('复制成功');
        this.shareImgs = false;
        // 释放内存
        clipboard.destroy()
      })
      clipboard.on('error', e => {
        // 不支持复制
        this.$message.success('该浏览器不支持自动复制')
        // 释放内存
        clipboard.destroy()
      })
    },
    showYue() {
      this.urls = '[{"amount":25,"giftBalance":0},{"amount":35,"giftBalance":0.5},{"amount":50,"giftBalance":1},{"amount":100,"giftBalance":2},{"amount":200,"giftBalance":5},{"amount":500,"giftBalance":20}]'
      this.shareImgs = true;
    },
    cancel() {
      this.shareImgs = false;
      this.addGroupVisibale = false;
      this.$refs.addOrEditGroupForm.resetFields();
    },
    cancel1() {
      this.shareImgs = false;
    },
    showbtnText(state) {
      return common.showTxtByState(state, { 0: '启用', 1: '禁用' })
    },
    getPkgGroupListPageHandle($event) {
      common.resetCurrentPage(this, $event, 'tbpg');
      var data = common.getRequestParams(this, 'tbpg', this.searchForm);

      common.sysRequest('pkg/group/listPage/pay', data, 'post').then(res => {
        common.listCallback(this, res, 'tbpg');
      })
    },
    showAddPkgGroup() {
      this.addGroupVisibale = true;
      this.addFlag = true;
      this.title = "新增";
      for (let val in this.addOrEditGroupForm) {
        this.addOrEditGroupForm[val] = "";
      }
    },
    showEditPkgGroup(row) {
      this.addGroupVisibale = true;
      this.addFlag = false;
      this.title = "修改";

      this.addOrEditGroupForm.id = row.id;
      this.addOrEditGroupForm.sysRemark = row.sysRemark;
      this.addOrEditGroupForm.maxPrice = row.maxPrice;
      this.addOrEditGroupForm.mchId = row.mchId;
      this.addOrEditGroupForm.mchPwd = row.mchPwd;
      this.addOrEditGroupForm.mchPwdKey = row.mchPwdKey;
      this.addOrEditGroupForm.subType = row.subType;
      this.addOrEditGroupForm.subState = row.subState;
      this.addOrEditGroupForm.remark = row.remark;
    },
    addOrEidtGroupHandle() {
      var _this = this;
      this.$refs.addOrEditGroupForm.validate(valid => {
        if (valid) {
          var data = this.addOrEditGroupForm;
          if (this.addFlag == true) {
            common.sysRequest('pkg/group/add/pay', data, 'post').then(res => {
              if (res.data.code == 200) {
                _this.getPkgGroupListPageHandle();
                _this.addGroupVisibale = false;
                _this.$message.success(res.data.message)
              } else {
                _this.$message.error(res.data.message)
              }
            })
            addPkgGroup(data).then(res => callback(res))
          } else {
            common.sysRequest('pkg/group/update/pay', data, 'post').then(res => {
              if (res.data.code == 200) {
                _this.getPkgGroupListPageHandle();
                _this.addGroupVisibale = false;
                _this.$message.success(res.data.message)
              } else {
                _this.$message.error(res.data.message)
              }
            })
          }
        }
      })
    },
    changeStateHandle(id) {
      var _this = this;
      var data = {
        id
      }
      this.$confirm('确定要删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        common.sysRequest('pkg/group/delete/pay', data, 'post').then(res => {
          if (res.data.code == 200) {
            _this.getPkgGroupListPageHandle();
            _this.$message.success(res.data.message)
          } else {
            _this.$message.error(res.data.message)
          }
        })
      }).catch(() => {

      });



    },
    handleSizeChange(val) {
      this.tbpg.pageSize = val;
      this.getPkgGroupListPageHandle();
    },
    handleCurrentChange(val) {
      this.tbpg.currentPage = val
      this.getPkgGroupListPageHandle();
    }
  },
  created() {
    this.getPkgGroupListPageHandle();
    common.getPkgTypeOptionCom(this, 'pkgTypeOption');
    common.getSupplierOptionCom(this, 'supplierOption');
    common.getSupplierLimitOptionCom(this, 'branchSupplierOption')
    common.getSupplierLimitOptionComs(this, 'branchSupplierOptions')
    getPkgIsMonthOption().then(res => {
      if (res.data.code == 200) {
        this.isMonthOption = res.data.data;
      } else {
        this.$message.error(res.data.message);
      }
    })
  }
}
</script>
<style></style>
